import React from 'react'
import { Box, Container, Text } from 'theme-ui'

const Footer = () => {
  const date = new Date()
  const getYear = date.getFullYear()

  return (
    <Container bg="primary" p={2} sx={{ bottom: '0px' }}>
      <Box sx={{ textAlign: 'center' }}>
        <Text color="white">{`Whistle Blowing System - Copyright © BPKH ${getYear}`}</Text>
      </Box>
    </Container>
  )
}

export default Footer
